export enum MailingStatus {
    pending = 1,
    inProgress,
    finished,
    canceled
}